import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

// Images (import your actual images here)
import heroBg from "../assets/images/about/banner.png";
import missionImg from "../assets/images/about/ourmission.png";
import visionImg from "../assets/images/about/ourvision.png";

import ctaBg from "../assets/images/andaman2.webp";
import "../assets/css/aboutus.css";

function About() {
  return (
    <>
      <Navbar />

      {/* Font Awesome CDN - Required for icons */}
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />

      {/* ========== SIMPLE BANNER SECTION ========== */}
      <div
        className="about-banner"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(0,0,0,0.55), rgba(0,0,0,0.35)), url(${heroBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          minHeight: "45vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <div className="container text-center" style={{ position: "relative", zIndex: 2 }}>
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <h1 className="banner-title animate-fade-up">About Us</h1>
              <p className="banner-subtitle animate-fade-up-delay">About Gypsy Companion</p>
            </div>
          </div>
        </div>
      </div>

      {/* ========== ABOUT GYPSY COMPANION INTRO SECTION ========== */}
      <div className="site-section py-5">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-10">
              <div className="section-badge d-inline-block">About Gypsy Companion</div>
              <h2 className="section-title text-center" >
                Offbeat Travel & Unique Experiences in India
              </h2>
              <p className="section-text-large">
                Gypsy Companion is a trusted name in offbeat travel experiences in India,
                offering journeys that go beyond traditional tourism. From spiritual yatras
                to wildlife safaris and group adventures, we create travel experiences that
                are meaningful, safe, and memorable.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* ========== OUR MISSION SECTION ========== */}
      <div className="site-section py-5">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 order-lg-1 order-2 blog">
              <div className="section-badge">What Drives Us</div>
              <h2 className="section-title">Our Mission</h2>
              <p className="section-text">
                Our mission is to deliver safe, comfortable, and unforgettable travel experiences
                that connect people with nature, adventure, and spirituality.
              </p>
              <div className="mission-icon-box mt-4">
                <div className="icon-item">
                  <i className="fas fa-shield-alt"></i>
                  <span>Safety First</span>
                </div>
                <div className="icon-item">
                  <i className="fas fa-heart"></i>
                  <span>Memorable Journeys</span>
                </div>
                <div className="icon-item">
                  <i className="fas fa-hands-helping"></i>
                  <span>Meaningful Connections</span>
                </div>
              </div>
            </div>
            <div className="col-lg-6 order-lg-2 order-1 ">
              <div className="img-wrapper effect-zoom">
                <img
                  src={missionImg}
                  alt="Our Mission"
                  className="img-fluid rounded-custom"
                  style={{ minWidth: "500px", width: "100%", objectFit: "cover" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ========== OUR VISION SECTION ========== */}
      <div className="site-section py-5 bg-light">
        <div className="container">
          <div className="row align-items-center g-5 flex-row-reverse blog1">
            <div className="col-lg-6">
              <div className="section-badge">Our Aspiration</div>
              <h2 className="section-title">Our Vision</h2>
              <p className="section-text">
                Our vision is to become a leading offbeat travel company in India, known for unique
                journeys that inspire people to explore beyond the ordinary.
              </p>
              <div className="vision-quote mt-4">
                <i className="fas fa-quote-left"></i>
                <p>“Travel not to escape life, but to let life not escape you.”</p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="img-wrapper effect-scale">
                <img
                  src={visionImg}
                  alt="Our Vision"
                  className="img-fluid rounded-custom"
                  style={{ minWidth: "500px", width: "100%", objectFit: "cover" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ========== WHY CHOOSE US SECTION - ALL ICONS NOW WORKING ========== */}
      <div className="site-section py-5">
        <div className="container">
          <div className="text-center mb-5">
            <div className="section-badge d-inline-block">Why Trust Us</div>
            <h2 className="section-title display-6">Why Choose Gypsy Companion</h2>
          </div>
          <div className="row g-4">
            {[
              { icon: "fa-map-marked-alt", title: "Professionally planned itineraries", desc: "Expertly crafted routes for maximum enjoyment" },
              { icon: "fa-chalkboard-teacher", title: "Experienced guides and tour leaders", desc: "Knowledgeable locals who love their land" },
              { icon: "fa-shield-alt", title: "Strong focus on safety and comfort", desc: "Your wellbeing is our top priority" },
              { icon: "fa-mountain", title: "Unique and offbeat destinations", desc: "Discover hidden gems beyond tourist traps" },
              { icon: "fa-hand-holding-heart", title: "Special care for senior citizens", desc: "Respectful & comfortable travel for all ages" },
            ].map((item, idx) => (
              <div className="col-md-6 col-lg-4" key={idx}>
                <div className="why-card">
                  <div className="why-icon">
                    <i className={`fas ${item.icon}`}></i>
                  </div>
                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ========== STATS / TRUST BANNER ========== */}
      <div className="stats-banner">
        <div className="container">
          <div className="row text-center g-4">
            <div className="col-md-3 col-6">
              <div className="stat-item">
                <span className="stat-number">5000+</span>
                <span className="stat-label">Happy Travelers</span>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="stat-item">
                <span className="stat-number">50+</span>
                <span className="stat-label">Destinations</span>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="stat-item">
                <span className="stat-number">100+</span>
                <span className="stat-label">Tours Completed</span>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="stat-item">
                <span className="stat-number">4.9</span>
                <span className="stat-label">Customer Rating</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ========== CTA SECTION ========== */}
      <div
        className="cta-section"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(108, 239, 130, 0.92), rgba(108, 239, 121, 0.85)), url(${ctaBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
        }}
      >
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h2 className="display-5 fw-bold text-white mb-4">Experience Travel Differently</h2>
              <p className="lead text-white mb-5">
                With Gypsy Companion, travel is more than just visiting places—it's about experiencing life,
                culture, and nature in its purest form.
              </p>
              <div className="cta-buttons row">
                <div className="col-12 col-md-6">
                  <a href="/contact" className="btn-cta-primary w-100">
                    <i className="fas fa-calendar-check"></i> Book Your Journey Today
                  </a>
                </div>

                <div className="col-12 col-md-6">
                  <a href="/tour" className="btn-cta-outline w-100">
                    <i className="fas fa-compass"></i> Explore Tours
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <style>{`
        /* ===== CSS STYLES ===== */
        .about-banner {
          position: relative;
          overflow: hidden;
        }
        .about-banner::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: radial-gradient(circle at 20% 40%, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.5) 100%);
          z-index: 1;
        }
        .banner-title {
          font-size: 4rem;
          font-weight: 800;
          color: white;
          margin-bottom: 0.5rem;
          letter-spacing: -0.5px;
          text-shadow: 2px 2px 8px rgba(0,0,0,0.3);
        }
        .banner-subtitle {
          font-size: 1.3rem;
          color: rgba(255,255,255,0.95);
          font-weight: 500;
          letter-spacing: 1px;
        }
        .section-text-large {
          font-size: 1.2rem;
          line-height: 1.8;
          color: #4a5568;
          max-width: 900px;
          margin: 0 auto;
        }
        .animate-fade-up {
          animation: fadeUp 0.8s ease forwards;
        }
        .animate-fade-up-delay {
          animation: fadeUp 0.8s ease 0.2s forwards;
          opacity: 0;
        }
        @keyframes fadeUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .section-badge {
          display: inline-block;
          background: #a2f44a20;
          color: #a2f44a;
          padding: 6px 16px;
          border-radius: 40px;
          font-size: 0.8rem;
          font-weight: 600;
          letter-spacing: 1px;
          margin-bottom: 1rem;
        }
        .section-title {
          font-size: 2.5rem;
          font-weight: 700;
          color: #1a2a3a;
          margin-bottom: 1.5rem;
          position: relative;
        }
        .section-title:after {
          content: '';
          position: absolute;
          bottom: -12px;
          left: 0;
          width: 70px;
          height: 4px;
          background: #a2f44a;
          border-radius: 4px;
        }
        .text-center .section-title:after {
          left: 50%;
          transform: translateX(-50%);
        }
        .section-text {
          font-size: 1.1rem;
          line-height: 1.7;
          color: #4a5568;
        }
        .rounded-custom {
          border-radius: 0 40px 0 40px;
          transition: all 0.4s ease;
          box-shadow: 0 20px 35px -12px rgba(0,0,0,0.2);
        }
        .img-wrapper {
          overflow: hidden;
          border-radius: 0 40px 0 40px;
        }
        .effect-zoom img {
          transition: transform 0.5s ease;
        }
        .effect-zoom:hover img {
          transform: scale(1.05);
        }
        .effect-scale img {
          transition: transform 0.4s ease;
        }
        .effect-scale:hover img {
          transform: scale(1.03);
        }
        .mission-icon-box {
          display: flex;
          gap: 1.8rem;
          margin-top: 2rem;
          flex-wrap: wrap;
        }
        .icon-item {
          display: flex;
          align-items: center;
          gap: 10px;
          background: #f8f9fa;
          padding: 10px 20px;
          border-radius: 50px;
          font-weight: 500;
          color: #2c3e50;
          box-shadow: 0 2px 8px rgba(0,0,0,0.05);
        }
        .icon-item i {
          font-size: 1.2rem;
          color: #a2f44a;
        }
        .vision-quote {
          background: #fef5e8;
          padding: 1.5rem 2rem;
          border-radius: 20px;
          border-left: 5px solid #a2f44a;
          position: relative;
        }
        .vision-quote i {
          color: #a2f44a;
          font-size: 2rem;
          opacity: 0.3;
          position: absolute;
          top: 10px;
          left: 20px;
        }
        .vision-quote p {
          font-size: 1.1rem;
          font-style: italic;
          margin-bottom: 0;
          padding-left: 2rem;
          color: #2d3e50;
        }
        .why-card {
          background: #fff;
          border-radius: 24px;
          padding: 2rem 1.5rem;
          text-align: center;
          transition: all 0.3s ease;
          box-shadow: 0 10px 25px -8px rgba(0,0,0,0.08);
          border: 1px solid #f0f0f0;
          height: 100%;
        }
        .why-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 25px 35px -12px rgba(0,0,0,0.15);
          border-color: #a2f44a30;
        }
        .why-icon {
          width: 75px;
          height: 75px;
          background: linear-gradient(135deg, #a2f44a20, #a2f44a10);
          border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.2rem;
        }
        .why-icon i {
          font-size: 2.5rem;
          color: #a2f44a;
        }
        .why-card h4 {
          font-size: 1.25rem;
          font-weight: 600;
          margin-bottom: 0.75rem;
          color: #1e2a3a;
        }
        .why-card p {
          color: #6c757d;
          font-size: 0.9rem;
        }
        .stats-banner {
          background: #1e2a3a;
          padding: 3rem 0;
          margin: 2rem 0;
        }
        .stat-item {
          text-align: center;
        }
        .stat-number {
          display: block;
          font-size: 2.8rem;
          font-weight: 800;
          color: #a2f44a;
          line-height: 1.2;
        }
        .stat-label {
          font-size: 0.9rem;
          text-transform: uppercase;
          letter-spacing: 1px;
          color: #cbd5e1;
        }
        .cta-section {
          padding: 5rem 0;
          text-align: center;
          background-attachment: fixed;
        }
        .btn-cta-primary {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          background: #fff;
          color: #a2f44a;
          padding: 14px 32px;
          border-radius: 50px;
          font-weight: 700;
          text-decoration: none;
          transition: 0.3s;
          margin: 0 10px;
          box-shadow: 0 10px 20px rgba(0,0,0,0.1);
        }
        .btn-cta-primary:hover {
          transform: translateY(-3px);
          background: #ffffff;
          color: #a2f44a;
          box-shadow: 0 20px 30px rgba(0,0,0,0.15);
        }
        .btn-cta-outline {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          background: transparent;
          border: 2px solid white;
          color: white;
          padding: 12px 28px;
          border-radius: 50px;
          font-weight: 600;
          text-decoration: none;
          transition: 0.3s;
          margin: 0 10px;
        }
        .btn-cta-outline:hover {
          background: white;
          color: #a2f44a;
          transform: translateY(-3px);
        }
        .bg-light {
          background-color: #f9fafb !important;
        }
        @media (max-width: 768px) {
          .banner-title {
            font-size: 2.5rem;
          }
          .banner-subtitle {
            font-size: 1rem;
          }
          .section-title {
            font-size: 1.8rem;
          }
          .section-text-large {
            font-size: 1rem;
          }
          .btn-cta-primary, .btn-cta-outline {
            margin: 10px;
            padding: 10px 20px;
            font-size: 0.9rem;
          }
          .img-wrapper img {
            min-width: 100% !important;
          }
          .stats-banner .stat-number {
            font-size: 2rem;
          }
        }
        @media (min-width: 992px) {
          .img-wrapper img {
            min-width: 500px;
            width: 100%;
            height: auto;
          }
        }
      `}</style>
    </>
  );
}

export default About;